import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AuthService } from '../auth/auth.service';
import { LoadingModule } from 'ngx-loading';
import { SharedModule } from '../shared/shared.module';
import { SalesInvoiceoutingModule } from './sales-invoice-routing.module';
import { SalesInvoiceComponent } from './sales-invoice.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    LoadingModule,
    SalesInvoiceoutingModule,
    ReactiveFormsModule,
    SharedModule
  ],
  declarations: [SalesInvoiceComponent],
  providers: [AuthService]
})
export class SalesInvoiceModule { }



// WEBPACK FOOTER //
// ./src/app/sales-invoice/sales-invoice.module.ts